const prompt = document.querySelector('.prompt');
const promptMain = document.querySelector('#promptMain');

const form = document.querySelector('.prompt__form');
const infoFieldset = document.querySelector('.prompt__info-fieldset');
const infoInputs = infoFieldset.querySelectorAll('input');
const infoInput = document.querySelector('#noInfo');

const difficultyCheckboxes = document.querySelectorAll('input[name="difficulty"]');
const difficultyRatios = document.querySelectorAll('input[name="difficultyRatio"]');

const typeCheckboxes = document.querySelectorAll('input[name="questionType"]');
const typeRatios = document.querySelectorAll('input[name="questionRatio"]');

const copyBtn = document.querySelector('#copyBtn');

/**
 * Shows and hides Input fields based on checkbox
 */
infoInput.addEventListener('change', function(){
    if(infoInput.checked) {
        infoFieldset.style.display = 'none';
        infoInputs.forEach(input => input.required = false);
    } else {
        infoFieldset.style.display = 'block';
        infoInputs.forEach(input => input.required = true);
    }
});

/**
 * Adds event listeners to checkboxes to toggle inputs
 * 
 * @param {Array} checkboxArray Array of checkboxes that toggle inputs
 * @param {Array} inputArray Array of inputs to be toggled
 */
function toggleInput(checkboxArray, inputArray) {
    checkboxArray.forEach((checkbox, i) => {
        checkbox.addEventListener('change', function() {
            if(checkbox.checked) {
                inputArray[i].value = '1';
                inputArray[i].disabled = false;
            } else {
                inputArray[i].value = '0';
                inputArray[i].disabled = true;
            }
        })
    })
}
toggleInput(difficultyCheckboxes, difficultyRatios);
toggleInput(typeCheckboxes, typeRatios);


form.addEventListener('submit', function(e) {
    e.preventDefault();
    const dataArr = [...new FormData(form)];
    const dataObj = Object.fromEntries(dataArr.map(key => [key[0], key[1]]));
    generatePrompt(dataObj);

    // Animating the prompt to symbolise reload
    prompt.classList.remove('prompt--animation');
    prompt.classList.add('prompt--animation');
    setTimeout(function() {
        prompt.classList.remove('prompt--animation');
    }, 600);
});

/**
 * Generates promt text based on user Inputs
 * 
 * @param {Object} data data from form
 */
function generatePrompt(data) {
    const promptInfo = infoInput.checked ? '' : `Die Fragen sollten für Studierende im ${data.semester}. Semester des Studiengangs "${data.course}" (${document.querySelector('input[name="grad"]:checked').value}) geeignet sein. `;
    const promptText = `Erstelle einen neuen Datensatz mit ${data.questionCount} Fragen zum Thema "${data.subject}". Gib mir dabei ein JSON-Array zurück. ${promptInfo}Gehe von ${document.querySelector('input[name="previousKnowledge"]:checked').value} Vorkenntnissen aus. Erstelle Fragen im Verhältnis Single Choice:Multiple Choice:Zuordnung mit ${typeRatios[0].value}:${typeRatios[1].value}:${typeRatios[2].value} ${data.trap === 'on' ? 'Bei Multiple Choice dürfen auch keine oder eine Antwort richtig sein.' : 'Es sollen immer mindestens 2 Antworten bei Multiple Choice richtig sein.'} Erstelle Fragen mit den Schwierigkeiten 1:2:3:4 im Verhältnis ${difficultyRatios[0].value}:${difficultyRatios[1].value}:${difficultyRatios[2].value}:${difficultyRatios[3].value}.`;
    promptMain.textContent = promptText;
}

copyBtn.addEventListener('click', function() {
    p = prompt.innerText;
    navigator.clipboard.writeText(p);
})